import React from 'react';
import ReactSelectOriginal from 'react-select';
import ReactSelectCreatable from 'react-select/creatable';

export const Select = ({ ...props }) => <ReactSelect {...props} />;

export const SelectCreatable = React.forwardRef(({ ...props }, ref) => (
	<ReactSelectCreatable
		ref={ref}
		className="text-xs"
		getOptionValue={(option) => option.key}
		{...props}
	/>
));

export const ReactSelect = React.forwardRef(({ ...props }, ref) => (
	<ReactSelectOriginal className="text-xs" {...props} />
));
